import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { DataTable } from "@ventumsoftware/react-toolkit";
import moment from "moment/moment";
import React, { type FC } from "react";
import { useApi } from "../../api/APIContext";
import type { WhitelistedEmail } from "../../api/dto";
import { ContentContainer } from "../../components/content/ContentContainer";
import { PageHeader } from "../../components/content/PageHeader";
import { TablePlaceholder } from "../../components/data/TablePlaceholder";
import { Button, IconButton } from "../../components/form/Button";
import { Loading } from "../../components/Loading";
import { useModal } from "../../components/layout/ModalProvider";
import { Paragraph } from "../../components/Paragraph";
import { AddWhitelistedEmailModal } from "../../modals/AddWhitelistedEmailModal";
import { DeleteWhitelistedEmailModal } from "../../modals/DeleteWhitelistedEmailModal";

export const SettingsEmailImportPage: FC<{}> = (props) => {
  const { whitelistedEmails, loading } = useApi();
  const addEmailModal = useModal({
    title: "Email toevoegen",
    body: <AddWhitelistedEmailModal />,
    size: "md",
  });
  return (
    <ContentContainer size={"lg"}>
      <div className={"flex items-center justify-between"}>
        <PageHeader>E-mail import</PageHeader>
        <div>
          <Button
            type={"primary"}
            size={"md"}
            text={"Email toevoegen"}
            onClick={() => addEmailModal.open()}
          />
        </div>
      </div>
      <div className={"-mt-2 max-w-(--breakpoint-lg)"}>
        <Paragraph>
          CSV imports kunnen ook uitgevoerd worden door een of meerdere bestanden te mailen naar{" "}
          <strong>import@app.dijkgraaf-support.nl</strong>
        </Paragraph>
        <Paragraph>
          Om controle te houden over wie wel of niet gebruik mag maken van deze functie, wordt de
          import alleen uitgevoerd bij bekende afzenders. Als de afzender in de onderstaande lijst
          staat, kunnen ze gebruik maken van de e-mail import functie.
        </Paragraph>
      </div>
      <Loading loading={loading}>
        {whitelistedEmails.length === 0 ? (
          <TablePlaceholder>Geen emails gevonden</TablePlaceholder>
        ) : (
          <DataTable
            keyProperty={"id"}
            data={whitelistedEmails}
            pageSize={50}
            columns={[
              { header: "email", sort: true, property: "email" },
              {
                header: "toegevoegd op",
                property: "createdAt",
                transform: (_, row) => moment(row.createdAt).format("YYYY-MM-DD"),
              },
              {
                header: "",
                property: "id",
                transform: (_, row) => {
                  return <WhitelistedEmailsTableControls key={row.id} whitelistedEmail={row} />;
                },
              },
            ]}
          />
        )}
      </Loading>
    </ContentContainer>
  );
};

const WhitelistedEmailsTableControls: FC<{ whitelistedEmail: WhitelistedEmail }> = (props) => {
  const deleteModal = useModal({
    title: "Email verwijderen",
    body: <DeleteWhitelistedEmailModal whitelistedEmail={props.whitelistedEmail} />,
    size: "md",
  });
  return (
    <div className={"flex items-center justify-end space-x-2 -my-2"}>
      <IconButton type={"danger"} size={"sm"} icon={faTimes} onClick={() => deleteModal.open()} />
    </div>
  );
};
